import {
  childcareSupportChatResponseSchema,
  type CreateChildcareSupportChatRequest,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useMutation } from "@tanstack/react-query";

export function useCreateChildcareSupportChat() {
  return useMutation({
    mutationFn: async (params: CreateChildcareSupportChatRequest["data"]["attributes"]) => {
      const { workerId, placementId } = params;

      const response = await post({
        url: `/workers/${workerId}/childcare-support-chat`,
        data: {
          data: {
            type: "childcare-support-chat",
            attributes: {
              placementId,
              workerId,
            },
          },
        },
        responseSchema: childcareSupportChatResponseSchema,
      });

      logEvent(APP_V2_APP_EVENTS.CHILDCARE_SUPPORT_CHAT_CREATED, {
        placementId,
        workerId,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CHILDCARE_SUPPORT_CHAT_CREATION_FAILED,
    },
  });
}
